module.exports = __webpack_public_path__ + "static/img/aanchal_img_new2.6d3cb063.png";